// Binding 60-move rule: 90 + 30 base minutes + 60 * 30 / 60 increment minutes.
export const OLYMPIAD_MODEL_MINUTES = 150;
export const OLYMPIAD_TIME_BASIS = "60-move-rule-150-model-minutes";

export function normalizeBoardResult(result) {
  if (result == null || result === "") return null;
  if (["½-½", "1/2-1/2", "0.5-0.5"].includes(result)) return "1/2-1/2";
  if (["1-0", "0-1"].includes(result)) return result;
  const compact = String(result).replace(/\s/g, "").replace(/:/g, "-");
  if (["+-", "+--"].includes(compact)) return "+-";
  if (["-+", "--+"].includes(compact)) return "-+";
  if (["--", "---"].includes(compact)) return "--";
  throw new Error("Invalid board result.");
}
export const isForfeitResult = result => ["+-", "-+", "--"].includes(normalizeBoardResult(result));
export function boardScoresFromResult(result, teamAColor) {
  const normalized = normalizeBoardResult(result);
  if (!normalized) return null;
  if (normalized === "--") return [0, 0];
  if (normalized === "1/2-1/2") return [0.5, 0.5];
  const white = ["1-0", "+-"].includes(normalized) ? 1 : 0;
  return teamAColor === "white" ? [white, 1 - white] : [1 - white, white];
}
export function teamAScoreFromResult(result, teamAColor) {
  return boardScoresFromResult(result, teamAColor)?.[0] ?? null;
}
export function boardResultInputValue(result, teamAColor) {
  const normalized = normalizeBoardResult(result);
  if (!normalized) return "";
  if (normalized === "--") return "--";
  if (isForfeitResult(normalized)) return teamAColor === "white" ? normalized : normalized === "+-" ? "-+" : "+-";
  return teamAScoreFromResult(normalized, teamAColor);
}
export function boardResultLabel(result, teamAColor) {
  const scores = boardScoresFromResult(result, teamAColor);
  if (!scores) return "offen";
  return `${boardScoreLabel(scores[0])} – ${boardScoreLabel(scores[1])}${isForfeitResult(result) ? " · kampflos" : ""}`;
}
export function whiteResultFromTeamAScore(score, teamAColor) {
  if (score === "" || score == null) return null;
  if (["+-", "-+", "--"].includes(score)) {
    if (score === "--" || teamAColor === "white") return score;
    return score === "+-" ? "-+" : "+-";
  }
  if (![0, 0.5, 1].includes(Number(score))) throw new Error("Invalid team board score.");
  if (Number(score) === 0.5) return "1/2-1/2";
  return (Number(score) === 1) === (teamAColor === "white") ? "1-0" : "0-1";
}
export const boardScoreLabel = (value) => value == null ? "–" : `${Math.floor(value) || ""}${value % 1 ? "½" : value === 0 ? "0" : ""}`;
